import PropTypes from 'prop-types';
import React from 'react';
import { Typography, Stack, } from '@mui/material';

DistributorClaimApprovalHeader.propTypes = {
    headerName: PropTypes.string,
};

export default function DistributorClaimApprovalHeader({ headerName}) {

    

    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ padding: '0px 16px 10px 8px'}}>
            <Typography variant="h6" sx={{ fontSize: '0.9rem' }}>
                {headerName}
            </Typography>           
        </Stack>
    );
}

